import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';

import { NotificationTheme } from '@fcom/ui-components';

@Component({
  selector: 'fin-ancillary-header',
  templateUrl: 'ancillary-header.component.html',
  standalone: false,
})
export class AncillaryHeaderComponent implements OnInit {
  readonly NotificationTheme = NotificationTheme;

  @Input()
  title: string;

  @ViewChild('headerTitle', { static: true })
  headerTitle: ElementRef<HTMLHeadingElement>;

  ngOnInit(): void {
    setTimeout(() => {
      this.headerTitle.nativeElement.focus();
    }, 300);
  }
}
